import * as types from '../constants/ActionTypes';

const initialState = {
  ui: {
    isInfiniteLoading: true,
    isFinished: false,
    scrollTop: null,
    isPointLoading: true,
  },
  isMapLoading: false,
  objects: {
    data: null,
    total: null,
  },
  pins: {
    data: null,
    total: null,
  },
  points: {},
  pointsList: [],
  errors: [],
  isObjectsFetching: false,
};

export default function objects(state = initialState, action) {
  switch (action.type) {
    case types.SET_SCROLL_TOP:
      return { ...state, ui: { ...state.ui, scrollTop: action.payload } };

    case types.LOAD_OBJECTS_START:
      return {
        ...state,
        ui: { ...state.ui, isInfiniteLoading: true, isFinished: false },
        isObjectsFetching: true,
      };
    case types.LOAD_OBJECTS_SUCCESS: {
      const {
        clear,
        data: { data },
      } = action.payload;
      const rows = clear ? data.rows : [...(state.objects.data || []), ...data.rows];
      const isFinished = rows.length >= data.total;
      return {
        ...state,
        ui: { ...state.ui, isInfiniteLoading: false, isFinished },
        objects: {
          data: rows,
          total: data.total,
        },
        isObjectsFetching: false,
      };
    }

    case types.ADD_TO_FAVORITES_SUCCESS:
    case types.REMOVE_FROM_FAVORITES_SUCCESS: {
      const favorite = action.type === types.ADD_TO_FAVORITES_SUCCESS;
      const { buildingId } = action.payload;

      if (state.objects.data || state.points) {
        return {
          ...state,
          objects: {
            ...state.objects,
            data:
              state.objects.data &&
              state.objects.data.map((building) =>
                building.id === buildingId ? { ...building, favorite } : building
              ),
          },
          points: {
            ...state.points,
            [buildingId]: {
              ...state.points[buildingId],
              favorite,
            },
          },
          pointsList: Object.keys(state.pointsList).reduce((acc, longLat) => {
            acc[longLat] = state.pointsList[longLat].map((building) =>
              building.id === buildingId ? { ...building, favorite } : building
            );
            return acc;
          }, {}),
        };
      }
      return state;
    }

    case types.LOAD_OBJECTS_ERROR:
      return {
        ...state,
        ui: { ...state.ui, isInfiniteLoading: false },
        errors: [...state.errors, ...action.payload],
        isObjectsFetching: false,
      };

    case types.LOAD_PINS_START:
      return {
        ...state,
        isMapLoading: true,
        isObjectsFetching: true,
      };

    case types.LOAD_PINS_SUCCESS: {
      const {
        data: { data },
      } = action.payload;
      return {
        ...state,
        isMapLoading: false,
        isObjectsFetching: false,
        pins: {
          data: data.rows,
          total: data.total,
        },
      };
    }

    case types.LOAD_PINS_ERROR:
      return {
        ...state,
        isMapLoading: false,
        errors: [...state.errors, ...action.payload],
        isObjectsFetching: false,
      };

    case types.LOAD_POINT_START:
      return {
        ...state,
        ui: { ...state.ui, isPointLoading: true },
      };

    case types.LOAD_POINT_SUCCESS: {
      const {
        id,
        data: { data },
      } = action.payload;
      return {
        ...state,
        ui: { ...state.ui, isPointLoading: false },
        points: { ...state.points, [id]: data },
      };
    }

    case types.LOAD_POINT_ERROR:
      return {
        ...state,
        ui: { ...state.ui, isInfiniteLoading: false },
        errors: [...state.errors, ...action.payload],
      };

    case types.LOAD_POINT_LIST_START:
      return {
        ...state,
        ui: { ...state.ui, isPointListLoading: true },
      };

    case types.LOAD_POINT_LIST_SUCCESS: {
      const {
        id,
        data: { data },
      } = action.payload;
      return {
        ...state,
        ui: { ...state.ui, isPointListLoading: false },
        pointsList: { ...state.pointsList, [id]: data },
      };
    }

    case types.LOAD_POINT_LIST_ERROR:
      return {
        ...state,
        ui: { ...state.ui, isInfiniteLoading: false },
        errors: [...state.errors, ...action.payload],
      };

    case types.RESET_OBJECTS:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/objects.js